import { Modal, ModalSection } from '@monash/portal-react';
import HistoryTimeline from '../../../common/history-timeline/HistoryTimeline';

const HistoryModal = ({ open, title, message, history, setHistoryShown }) => {
  const closeHistory = () => {
    setHistoryShown(false);
  };
  return (
    <Modal open={open} onClose={closeHistory} ariaLabel={title}>
      <ModalSection title={title}>
        <p>{message}</p>
        {history && <HistoryTimeline history={history} />}
      </ModalSection>
    </Modal>
  );
};

export default HistoryModal;
